












































































import {Component, Vue, Watch} from 'vue-property-decorator';
import WhoAmIApi from "../src/repository/WhoAmIApi";
@Component({
    components: {

    },
    name: 'default',
})
export default class defaultTheme extends Vue{

    async created() {
        let api = new WhoAmIApi()
        let result = await api.getIsEmailMenuVisible()
        if (!result){
            var itm: any = this;
            itm.items.shift()
        }
    }
    data () {
        return {
            clipped: false,
            drawer: true,
            fixed: false,
            items: [
                {
                    id: 0,
                    icon: 'mail_outline',
                    title: 'Email Archive',
                    path: '/'
                },
                {
                    id:1,
                    icon: 'business_center',
                    title: 'Collaborate',
                    path: '/collaborate'
                }
            ],
            miniVariant: true,
            right: true,
            rightDrawer: false,
            //title: 'Message Hub'
        }
    }
    async logout(){
        await this.axios.get('https://api.messagehub.ca/auth/logout',{
            withCredentials: true
        })
        sessionStorage.removeItem('verifiedAuthStatus')
        window.location.assign('/login')
    }
}
